exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrollable-list-group[data-v-6acc2b11]{max-height:480px;overflow-y:auto}", ""]);

// exports
